import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'
import URL from 'url'
import { parseQueryString } from 'utils/query'

export const useUrl = () => {
  const { asPath } = useRouter()
  const [url, setUrl] = useState(URL.parse(asPath))
  const [query, setQuery] = useState(parseQueryString(url.search))

  useEffect(() => {
    const newUrl = URL.parse(asPath)
    const newQuery = parseQueryString(newUrl.search)
    setUrl(newUrl)
    setQuery(newQuery)
  }, [asPath])

  return { url, query }
}
